module.exports = __webpack_public_path__ + "images/portfolio4-cb8f109a81abf0d1fc220262b9af704c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/portfolio4.jpg
// module id = 17
// module chunks = 0